import React from "react";
import '../../styles/Contact.css';

function Aviso() {
    return (
        <div>
            <h2>Aviso de privacidad</h2>
        </div>
    );
}

export default Aviso;